import { SettingsPermissions } from "@redotech/account-common/permissions";
import { directMerchantAccess } from "../../settings-catalog/access";
import type {
  SettingGroupDefinition,
  SettingOwner,
  SettingRisk,
} from "../../settings-catalog/types";

export type CustomerPortalAbTestAnalyticsFlatTeamSettingGroupId =
  "customer_portal_ab_test_analytics.overview";

const customerportalabtestanalyticsOwner: SettingOwner = {
  kind: "teamSettings",
  product: "returns",
};

const customerportalabtestanalyticsRisk: SettingRisk = {
  level: "low",
  reason: "Read-only AB test analytics.",
};

export const CustomerPortalAbTestAnalyticsFlatTeamSettingGroups = [
  {
    id: "customer_portal_ab_test_analytics.overview",
    title: "AB test analytics",
    description: "AB test analytics for customer portal flows.",
    productArea: "returns",
    access: directMerchantAccess(
      SettingsPermissions.SET_RETURNS_AND_CLAIMS_SETTINGS,
    ),
    owner: customerportalabtestanalyticsOwner,
    risk: customerportalabtestanalyticsRisk,
    agentEditability: { mode: "requiresApproval" },
    fullPageTarget: {
      type: "settings",
      path: "customer-portal/flows/ab-test-analytics",
    },
    synonyms: [
      "ab test analytics",
      "ab test results",
      "ab test results for my return flows",
      "see ab test results for return flows",
      "results of return flow ab tests",
      "return flow ab test results",
      "flow test results",
      "split test analytics",
      "flow analytics",
    ],
  },
] as const satisfies readonly SettingGroupDefinition<CustomerPortalAbTestAnalyticsFlatTeamSettingGroupId>[];
